<template>
    <div class="typeAnswer" :class="accordionClasses">
        <div 
            class="type-wrapper message-header" 
            @click="toggleAnswer" 
            tabindex="0"
            @keyup.enter="toggleAnswer"
            @keyup.space="toggleAnswer"
        >
            <p>
                {{ type.question }}
            </p>
            <div class="icon-wrapper">
                <i class="input-icon icon-chevron-up"></i>
            </div>
        </div>
        <div class="type-wrapper message-body">
            <p tabindex="0">
                {{ type.answer }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TypeAnswer',
    props: {
        type: Object
    },
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        toggleAnswer() {
            this.isOpen = !this.isOpen;
        },
    },
    computed: {
        accordionClasses: function () {
            return {
                'is-closed': !this.isOpen,
                'is-primary': this.isOpen,
            };
        }
    }
}
</script>